import React from 'react';
import PropTypes from 'prop-types';


const MobileDateFilter = ({ onClick, selectedDate, dates, brandClass }) => (
  <div className="react-day-filter-mobile-container">
    <div className={`react-mozi-brand ${brandClass} react-filter-mobile-title`}>Válassz napot!</div>
    <div className={`react-mozi-brand ${brandClass} react-active react-filter-mobile-box`} tabIndex={0} role="button" onClick={onClick}>
      <div className="react-day-filter-mobil-box-title">{dates && dates.length > 0 ? dates.find(date => date.dateId === selectedDate).day : ''}</div>
      <div className="react-day-filter-mobil-box-title-date">{dates && dates.length > 0 ? dates.find(date => date.dateId === selectedDate).date : ''}</div>
    </div>
  </div>
);

MobileDateFilter.propTypes = {
  brandClass: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  selectedDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({}),
  ]).isRequired,
  dates: PropTypes.arrayOf(PropTypes.shape({})),
};

MobileDateFilter.defaultProps = {
  dates: null,
};

export default MobileDateFilter;
